// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface INmvtisActionTakenType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class NmvtisActionTakenType implements INmvtisActionTakenType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns InProgress NmvtisStolenVehicleReportStatusType
	**/
    get Exitingtostartwithdifferentvehicle(): INmvtisActionTakenType {
        return this.FromId(1);
    }
    /**
		Returns Proceedingwithservice NmvtisStolenVehicleReportStatusType
	**/
    get Proceedingwithservice(): INmvtisActionTakenType {
        return this.FromId(2);
    }

    get ReferringforLevel23VInspection(): INmvtisActionTakenType {
        return this.FromId(3);
    }
    get Sentcustomerawayforpolicereport(): INmvtisActionTakenType {
        return this.FromId(4);
    }
    get Updatingtosalvageintoinsurancecompanysname(): INmvtisActionTakenType {
        return this.FromId(5);
    }
    get WaitingforLocalLawEnforcementtorespond(): INmvtisActionTakenType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);
    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Exitingtostartwithdifferentvehicle', displayValue: 'Exiting to start with different vehicle', description: 'Exiting to start with different vehicle', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Proceedingwithservice', displayValue: 'Proceeding with service', description: 'Proceeding with service', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'ReferringforLevelII/IIIInspection', displayValue: 'Referring for Level II / III Inspection', description: 'Referring for Level II / III Inspection', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'Sentcustomerawayforpolicereport', displayValue: 'Sent customer away for police report', description: 'Sent customer away for police report', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'Updatingtosalvageintoinsurancecompanysname', displayValue: 'Updating to salvage into insurance company\'s name', description: 'Refer to Remarks', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'WaitingforLocalLawEnforcementtorespond', displayValue: 'Waiting for Local LE to respond', description: 'Waiting for Local LE to respond', sortOrder: 6, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): INmvtisActionTakenType {
        return this._dictionary[id];
    }

    public FromValue(value: string): INmvtisActionTakenType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): INmvtisActionTakenType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): INmvtisActionTakenType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): INmvtisActionTakenType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
